export class IdGuidNameCombination {
    ID: number;
    Guid: string;
    Name: string;
    disabled?: boolean;
    isArchived?: boolean;

    constructor(i: number, g: string, n: string) {
        this.ID = i;
        this.Guid = g;
        this.Name = n;
    }
}
